import React, { FunctionComponent } from 'react';

import { isString } from 'lodash';

import { SourceId } from 'admin/sources/Sources';
import { ContextProps } from 'reviews2/feed/review-yeti/Review.types';

import 'reviews2/feed/review-yeti/template/field/TemplateFieldProperty.scss';

export const TemplateFieldProperty: FunctionComponent<ContextProps> = ({ context }) => {
    const { review } = context;
    const propertyFields = review.properties || [];
    const reviewProperties = review!.review_rating_properties || [];

    if (!propertyFields?.length && !reviewProperties?.length) {
        return null;
    }

    return (
        <div className="r4e-review-template-field-property">
            {[...reviewProperties, ...propertyFields]?.map((property: any) => {
                if (review.review_source_id === SourceId.Facebook && property.key === 'Recommended') {
                    // we display the Facebook recommends in the rating component
                    return null;
                }

                return (
                    <div className="property-value" key={property.key}>
                        <span className="text-muted">{property.key}</span>
                        <span>{isString(property.value) ? property.value : property.value?.join(', ')}</span>
                    </div>
                );
            })}
        </div>
    );
};
